<div 
  class="relative overflow-hidden"
  [ngClass]="[getSizeClass(), isCircular() ? 'rounded-full' : 'rounded-lg']"
  (mouseenter)="isHovering = editable()"
  (mouseleave)="isHovering = false">
  
  <img 
  (click)="action.emit()"
    [src]="image ?? '/images/user_image.png'" 
    class="w-full h-full object-cover"
    [ngClass]="isCircular() ? 'rounded-full' : 'rounded-lg'" />

  <div *ngIf="editable() && isHovering" 
       class="absolute inset-0 bg-black/50 flex items-center justify-center space-x-4"
       [ngClass]="isCircular() ? 'rounded-full' : 'rounded-lg'">
    
    <label class="cursor-pointer text-white text-lg flex flex-col items-center"
           [ngClass]="!excludableValue ? 'justify-center' : ''">
      <ui-icon [icon]="EIcon.Edit" [size]="size()" [color]="EAlert.LIGHT"></ui-icon>
      <input #fileInput type="file" accept="image/*" (change)="onFileChange($event)" hidden />
    </label>

    <label *ngIf="excludableValue" class="cursor-pointer text-white text-lg flex flex-col items-center">
      <ui-icon [icon]="EIcon.Trash" [size]="size()" [color]="EAlert.LIGHT" (click)="onTrashClick($event)"></ui-icon>
    </label>
  </div>
</div>
